import { css } from '@emotion/css';
import { Spacing } from 'src/styles';

// AccountStatus styles
export const upload = css`
  .ant-upload-list-item-info {
    ${Spacing.mt0}
  }
`;
